module.exports = __webpack_public_path__ + "img/banner-together-n.bd6b2558.jpg";